// extracted by mini-css-extract-plugin
module.exports = {"page":"_4Tbw8UcfICV0kt0lOHGIxA=="};